import { useQuery } from '@tanstack/react-query';
import { billingKeys } from '../utils/queryClient';
import billingApi from '../utils/api/billingApi';

export function useSubscription(options = {}) {
    const { scope, ...queryOptions } = options;

    return useQuery({
        queryKey: billingKeys.subscription(scope),
        queryFn: () => billingApi.getSubscription(),
        staleTime: 1000 * 30,
        ...queryOptions
    });
}
